import _ from 'lodash';

export default {
  methods: {
    getSubscriptions(code = null) {
      return new Promise((resolve, reject) => {
        let url = '/users/me/available_subscriptions?provider=stripe';
        if (code !== null) {
          url += `&code=${code}`;
        }
        this.$api.get(url)
          .then((response) => {
            const { packages } = response.data;
            resolve(packages);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSubscriptionPackage(id, { code = null, customer = null, subscription = null }) {
      return new Promise((resolve, reject) => {
        let url = `/subscriptions/${id}?provider=stripe`;
        if (code !== null) {
          url += `&code=${code}`;
        }
        if (customer !== null) {
          url += `&customer=${customer}`;
        }
        if (subscription !== null) {
          url += `&subscription=${subscription}`;
        }
        this.$api.get(url)
          .then((response) => {
            // eslint-disable-next-line no-shadow
            const { subscription } = response.data;
            subscription.variants = _.sortBy(subscription.variants, (v) => v.max_devices);
            resolve(subscription);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateSubscription() {
      const data = {
        provider_ref: this.selectedPrice.payment_provider_ref,
        payment_provider_subscription_id: this.userStripeSubscription.payment_provider_subscription_id,
      };
      this.buttonGroupIsLoading('subscribe', true);
      this.$api.post('/subscriptions/stripe/update', data)
        .then((response) => {
          const paymentIntent = _.get(response, 'data.subscription.latest_invoice.payment_intent', null);
          return this.validatePayment(paymentIntent, this.defaultCardId);
        })
        .then((status) => {
          if (status === 'succeeded') {
            return Promise.resolve();
          }
          return this.$api.post('/subscriptions/stripe/update', data);
        })
        .then(() => {
          this.paymentMade();
        })
        .catch(() => this.$api.post('/subscriptions/stripe/update', data))
        .then((res) => {
          this.flashMessage(res, 'success');
        })
        .catch((error) => {
          this.flashMessage(error, 'error');
          this.cleanUpAfterPaymentAttempt();
        })
        .finally(() => {
          this.cleanUpAfterPaymentAttempt();
        });
    },
    reactivateSubscription() {
      this.buttonGroupIsLoading('subscribe', true);
      this.$api.post('/subscriptions/stripe/reactivate', { payment_provider_subscription_id: this.userStripeSubscription.payment_provider_subscription_id })
        .then((response) => {
          this.key++;
          this.flashMessage(response, 'success');
        })
        .catch((error) => {
          this.flashMessage(error, 'error');
        })
        .finally(() => {
          this.buttonGroupIsLoading('subscribe', false);
          this.modal.hide('reactivate');
          this.init();
        });
    },
  },
};
